import { httpUtil } from "./httpUtil";
import { ErrorCodes, createResult, createCommonResult } from "./resultUtil";

export const contacts = {
    registerByPhone,
    registerByGoogle,
    registerByFB,
    registerByEmail,
    authenticatePhone,
    authenticateEmail,
    authenticateFB,
    authenticateGoogle,
    authenticate,
    sendSMSOTP,
    validateOTP,
    sendEmailVerification,
    getContact,
    getContactDemographics,
    updateContact,
    updateContactDOB,
    updateContactNameday,
    updateContactConsents,
    updateContactLanguage,
    addAddress,
    getAddresses,
    updateAddress,
    removeAddress,
    getPhones,
    addPhone,
    updatePhone,
    deletePhone,
    getContactPurchases,
    addPNDeviceToken,
    changePassword,
    signOut,
    createReferral,
    getListPaymentMethods,
    removePaymentMethod,
    addPaymentMethod,
    createFormToAddCard,
    forgotPassword,
    setPrimaryCard,
    addApplicationUsage,
    addContactPreferences,
    getContactPreferences,
    addFingerprints,
    sendCredentialsOTP,
    validateCredentialsOTP,
    credentialsByEmail,
    credentialsByPhone,
    findAddress,
    reclaimPurchase,
    getContactTokens,
    requestContactToken,
    getNameDayRules,
    redeemAPass,
    getListContactServices,
    getApplePass,
    getGooglePass,
    getAndroidWalletPass,
    credentialsByEmailOTP,
    getContactDevices,
    getUsageServicesAllowance,
    onServiceDelivery,
    onUpdateService,
    onUpdateSubscription,
    getListServiceDevices,
    getCustomers,
    validateEmailOTP,
    onUpdateServiceWithBody,
    deleteContact,
    getSubscriptonActions,
    changeMwarePassword,
    getPurchaseInfo,
    sendCredentialsMultipleOTP,
    getListPaymentMethodsV2,
};

async function registerByPhone(
    {
        first_name,
        last_name,
        phone,
        country_code,
        referral_code,
        sms_opt_out,
        email_opt_out,
        country_agreement,
        custom_fields
    },
    startSession = false
) {
    try {
        let contact = {
            first_name,
            last_name,
            identity: {
                provider: "PHONE",
                phone_number: phone,
                country_code: country_code,
            },
            service_acceptance: "true",
            email_opt_out: !email_opt_out,
            sms_opt_out: !sms_opt_out,
            consent_state: "ACCEPTED",
            country_agreement: country_agreement,
            custom_fields: custom_fields
        };
        if (referral_code) {
            contact.referral_code = referral_code;
        }
        //console.log('Contact register phone API: ', contact);
        let response = await httpUtil.post({
            resourcePath: "/v1/contacts/register",
            body: contact,
            logOutIfSessionInvalid: false,
        });
        if (startSession == true && response.code == "OK") {
            httpUtil.startSession(response.data);
        }
        //check return code here instead of put as there would be different intepretation for different API
        console.log(response);
        if (response.code == "OK")
            return createResult(ErrorCodes.OK, response.data);
        else {
            if (
                response.error && (response.error.error == "COM.CRM.EXCEPTIONS.MORETHANONEENTITYEXISTSEXCEPTION" || response.error.error == 'CRM.EXCEPTIONS.MORETHANONEENTITYEXISTSEXCEPTION')
            ) {
                return createResult(
                    ErrorCodes.REGISTRATION_FAIL_CONTACT_EXISTS,
                    response.error
                );
            }else if(response.error && response.error.error == "CRM.EXCEPTIONS.INVALIDVALUEEXCEPTION"){
                return createResult(
                    ErrorCodes.INVALIDVALUEEXCEPTION,
                    response.error
                );
            }
             else 
                return createResult(ErrorCodes.UNCLASSIFIED_ERROR, response.error);
        }
    } catch (e) {
        console.log("Exception register: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function registerByEmail(
    {
        first_name,
        last_name,
        username,
        password,
        referral_code,
        sms_opt_out,
        email_opt_out,
        validation_required,
        country_agreement
    },
    startSession = false
) {
    try {
        var identity = {
            provider: "EMAIL",
            username,
            password,
        }
        if (validation_required != undefined) {
            identity.validation_required = validation_required ? validation_required : false
        }
        let contact = {
            first_name,
            last_name,
            identity: identity,
            service_acceptance: "true",
            email_opt_out: !email_opt_out,
            sms_opt_out: !sms_opt_out,
            consent_state: "ACCEPTED",
            country_agreement: country_agreement
        };
        if (referral_code) {
            contact.referral_code = referral_code;
        }
        //console.log('API: ', contact)
        let response = await httpUtil.post({
            resourcePath: "/v1/contacts/register",
            body: contact,
            logOutIfSessionInvalid: false,
        });
        if (startSession == true && response.code == "OK") {
            httpUtil.startSession(response.data);
        }
        //check return code here instead of put as there would be different intepretation for different API
        console.log(response);
        if (response.code == "OK")
            return createResult(ErrorCodes.OK, response.data);
        else {
            if (response.error && (response.error.error == "COM.CRM.EXCEPTIONS.MORETHANONEENTITYEXISTSEXCEPTION" || response.error.error == "CRM.EXCEPTIONS.MORETHANONEENTITYEXISTSEXCEPTION")) {
                return createResult(
                    ErrorCodes.REGISTRATION_FAIL_CONTACT_EXISTS,
                    response.error
                );
            } else if (
                response.error &&
                response.error.error ==
                "COM.CRM.EXCEPTIONS.INVALIDPASSWORDEXCEPTION"
            ) {
                return createResult(
                    ErrorCodes.INVALID_PASSWORD_EXCEPTION,
                    response.error
                );
            } else if (
                response.error &&
                response.error.error ==
                "COM.CRM.EXCEPTIONS.INVALIDCONTACTPASSWORDEXCEPTION"
            ) {
                return createResult(
                    "INVALID_CONTACTPASSWORD_EXCEPTION",
                    response.error
                );
            } else if(response.error && response.error.error == "CIMALREADYEXISTSFORANOTHERCONTACTEXCEPTION"){
                return createResult(
                    "CIMALREADYEXISTSFORANOTHERCONTACTEXCEPTION",
                    response.error
                );
            }
            else return createResult(ErrorCodes.UNCLASSIFIED_ERROR, response.error);
        }
    } catch (e) {
        console.log("Exception register: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function registerByFB(
    {
        first_name,
        last_name,
        fbID, //facebook ID
    },
    startSession = true
) {
    return registerBySocial(
        {
            first_name,
            last_name,
            token: fbID, //
        },
        startSession,
        "FACEBOOK"
    );
}

async function registerByGoogle(
    {
        first_name,
        last_name,
        googleId, //Google ID
    },
    startSession = true
) {
    return registerBySocial(
        {
            first_name,
            last_name,
            token: googleId, //
        },
        startSession,
        "GOOGLE"
    );
}

async function registerBySocial(
    {
        first_name,
        last_name,
        token, //facebook ID
    },
    startSession = true,
    provider
) {
    try {
        let contact = {
            first_name,
            last_name,
            identity: {
                provider: provider,
                token,
            },
            service_acceptance: "true",
            email_opt_out: "true",
            sms_opt_out: "true",
        };
        //console.log('API: ', contact)
        let response = await httpUtil.post({
            resourcePath: "/v1/contacts/register",
            body: contact,
            logOutIfSessionInvalid: false,
        });
        if (startSession == true && response.code == "OK") {
            httpUtil.startSession(response.data);
        }
        //check return code here instead of put as there would be different intepretation for different API
        //console.log(response);
        if (response.code == "OK")
            return createResult(ErrorCodes.OK, response.data);
        else {
            if (
                response.error &&
                response.error.error ==
                "COM.CRM.EXCEPTIONS.MORETHANONEENTITYEXISTSEXCEPTION"
            ) {
                return createResult(
                    ErrorCodes.REGISTRATION_FAIL_CONTACT_EXISTS,
                    response.error
                );
            } else return createResult(ErrorCodes.UNCLASSIFIED_ERROR, response.error);
        }
    } catch (e) {
        console.log("Exception register: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function authenticateFB({ challenge }, startSession = true) {
    return authenticate(
        {
            token: challenge,
            provider: "FACEBOOK",
        },
        startSession
    );
}

async function authenticateGoogle({ challenge }, startSession = true) {
    return authenticate(
        {
            token: challenge,
            provider: "GOOGLE",
        },
        startSession
    );
}

async function authenticatePhone(
    { phone_number, country_code, application_id },
    startSession = false
) {
    return authenticate(
        {
            phone_number,
            country_code,
            provider: "PHONE",
            application_id,
        },
        startSession
    );
}

async function authenticateEmail({ username, password, application_id }, startSession = true) {
    return authenticate(
        {
            username,
            password,
            application_id,
            provider: "EMAIL",
        },
        startSession
    );
}

async function authenticate(contact, startSession = true) {
    try {
        //console.log('API: ', contact)
        let response = await httpUtil.post({
            resourcePath: "/v1/contacts/authenticate",
            body: contact,
            logOutIfSessionInvalid: false,
        });
        if (startSession == true && response.code == "OK" && response.data && response.data.access_token) {
            httpUtil.startSession(response.data);
        }
        //check return code here instead of put as there would be different intepretation for different API
        if (response.code == "OK") {
            if (response.data.auth_otp || response.data.access_token) {
                return createResult(ErrorCodes.OK, response.data);
            } else {
                return createResult(ErrorCodes.INVALID_LOGIN, response.error);
            }
        }else {
            if (
                response.error &&
                response.error.message == "COM.CRM.EXCEPTIONS.INVALIDLOGINEXCEPTION"
            ) {
                return createResult(ErrorCodes.INVALID_LOGIN, response.error);
            } else if (response.error &&
                response.error.error == "COM.CRM.EXCEPTIONS.EMAILNOTVERIFIEDEXCEPTION") {
                return createResult(ErrorCodes.EMAIL_NOT_VERIFIED, response.error);
            } else if (response.code == '429' || response.code === 429) {
                return createResult(ErrorCodes.TOO_MANY_REQUESTS, response.error);
            }
            else return createResult(ErrorCodes.UNCLASSIFIED_ERROR, response.error);
        }
    } catch (e) {
        console.log("Exception register: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function sendSMSOTP(phone) {
    try {
        //console.log('API: ', contact)
        let response = await httpUtil.post({
            resourcePath: "/v1/contacts/otp",
            body: {
                send_method: "SMS",
                credentials: [
                    {
                        name: "PHONE",
                        value: phone,
                    },
                ],
            },
            logOutIfSessionInvalid: false
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception register: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function validateOTP({ phone, auth_otp, otp }, startSession = true) {
    try {
        //console.log('API: ', contact)
        let response = await httpUtil.post({
            resourcePath: "/v1/contacts/validate-otp",
            body: {
                credentials: [
                    {
                        name: "AUTH_OTP",
                        value: auth_otp,
                    },
                ],
                code: otp,
                remember_me: true,
            },
            logOutIfSessionInvalid: false
        });
        //check return code here instead of put as there would be different intepretation for different API
        if (startSession == true && response.code == "OK") {
            httpUtil.startSession(response.data);
        }
        if (response.code == "OK")
            return createResult(ErrorCodes.OK, response.data);
        else {
            if (
                response.error &&
                response.error.message == "COM.CRM.EXCEPTIONS.INVALIDLOGINEXCEPTION"
            ) {
                return createResult(ErrorCodes.INVALID_LOGIN, response.error);
            } else return createResult(ErrorCodes.UNCLASSIFIED_ERROR, response.error);
        }
    } catch (e) {
        console.log("Exception register: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function validateEmailOTP({ email, auth_otp, otp }, startSession = true) {
    try {
        //console.log('API: ', contact)
        let response = await httpUtil.post({
            resourcePath: "/v1/contacts/validate-otp",
            body: {
                credentials: [
                    {
                        name: auth_otp,
                        value: email,
                    },
                ],
                code: otp,
                remember_me: true,
            },
            logOutIfSessionInvalid: false
        });
        //check return code here instead of put as there would be different intepretation for different API
        if (startSession == true && response.code == "OK") {
            httpUtil.startSession(response.data);
        }
        if (response.code == "OK")
            return createResult(ErrorCodes.OK, response.data);
        else {
            if (
                response.error &&
                ((response.error.message == "COM.CRM.EXCEPTIONS.INVALIDLOGINEXCEPTION" || response.error.message == "CRM.EXCEPTIONS.INVALIDLOGINEXCEPTION") || response.error.error === 'CRM.EXCEPTIONS.INVALIDLOGINEXCEPTION')
            ) {
                return createResult(ErrorCodes.INVALID_LOGIN, response.error);
            } else return createResult(ErrorCodes.UNCLASSIFIED_ERROR, response.error);
        }
    } catch (e) {
        console.log("Exception register: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}
async function sendEmailVerification(email) {
    try {
        //console.log('API: ', contact)
        let response = await httpUtil.post({
            resourcePath: "/v1/contacts/email_verification",
            body: {
                credentials: [
                    {
                        name: "EMAIL",
                        value: email,
                    },
                ],
            },
            logOutIfSessionInvalid: false
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception register: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}
async function getContact() {
    try {
        let id = httpUtil.getSession().sub;
        //console.log('API: ', contact)
        let response = await httpUtil.get({
            resourcePath: "/v1/contacts/" + id,
            queryParams: { include_financials: true },
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception register: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getContactDemographics() {
    try {
        let id = httpUtil.getSession().sub;
        //console.log('API: ', contact)
        let response = await httpUtil.get({
            resourcePath: "/v1/contacts/" + id + "/demographics",
            withAccessToken: true,
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception register: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function updateContact(
    { first_name, last_name, email_address,statutory_number,},
    { gender, date_of_birth, name_day, passport, id_details,id_number},
    custom_fields,
) {
    console.log("date_of_birth:", date_of_birth)
    try {
        let id = httpUtil.getSession().sub;
        //console.log('API: ', contact)
        let response = await httpUtil.put({
            resourcePath: "/v1/contacts/" + id,
            body: {
                first_name,
                last_name,
                email_address,
                statutory_number,
                demographics: {
                    gender,
                    date_of_birth,
                    name_day,
                    passport,
                    id_details,
                    id_number
                },
                custom_fields,
            },
        });
        //check return code here instead of put as there would be different intepretation forGotr different API
        //return createCommonResult(response);
        if (response.code == "OK")
            return createResult(ErrorCodes.OK, response.data);
        else {
            if (
                response.error && (response.error.error == "COM.CRM.EXCEPTIONS.MORETHANONEENTITYEXISTSEXCEPTION" || response.error.error == 'CRM.EXCEPTIONS.MORETHANONEENTITYEXISTSEXCEPTION')
            ) {
                return createResult(
                    ErrorCodes.CUSTOMER_EMAIL_ALREADY_EXIST,
                    response.error
                );
            } else return createResult(ErrorCodes.UNCLASSIFIED_ERROR, response.error);
        }
    } catch (e) {
        console.log("Exception register: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}
async function updateContactDOB(date_of_birth) {
    try {
        let id = httpUtil.getSession().sub;
        //console.log('API: ', contact)
        let response = await httpUtil.put({
            resourcePath: "/v1/contacts/" + id,
            body: {
                demographics: {
                    date_of_birth,
                },
            },
        });
        //check return code here instead of put as there would be different intepretation forGotr different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception updateContactDOB: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function updateContactNameday(name_day) {
    try {
        let id = httpUtil.getSession().sub;
        //console.log('API: ', contact)
        let response = await httpUtil.put({
            resourcePath: "/v1/contacts/" + id,
            body: {
                demographics: {
                    name_day,
                },
            },
        });
        //check return code here instead of put as there would be different intepretation forGotr different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception updateContactDOB: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function updateContactConsents({ email_opt_out, sms_opt_out }) {
    try {
        let id = httpUtil.getSession().sub;
        //console.log('API: ', contact)
        let response = await httpUtil.put({
            resourcePath: "/v1/contacts/" + id,
            body: {
                email_opt_out,
                sms_opt_out,
            },
            withAccessToken: true,
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception updateContactConsents: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function updateContactLanguage(language) {
    try {
        let id = httpUtil.getSession().sub;
        //console.log('API: ', contact)
        let response = await httpUtil.put({
            resourcePath: "/v1/contacts/" + id,
            body: {
                preferred_language_code: language,
            },
            withAccessToken: true,
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception updateContactConsents: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function addAddress({
    address_type,
    address_line_1,
    address_line_2,
    address_name,
    state_province_county,
    town_city,
    postal_code,
    country_code,
    lat,
    lon,
    is_primary = true,
}) {
    try {
        //console.log('API: ', contact)
        let id = httpUtil.getSession().sub;
        //console.log('API: ', contact)
        let response = await httpUtil.post({
            resourcePath: "/v1/contacts/" + id + "/addresses",
            body: {
                address_type,
                address_name,
                address_line_1,
                address_line_2,
                state_province_county,
                town_city,
                postal_code,
                country_code,
                lat,
                lon,
                is_primary,
            },
            withAccessToken: true,
        });
        if (response.code == "OK")
            return createResult(ErrorCodes.OK, response.data);
        else {
            if (
                response.error && (
                    response.error.error == "COM.CRM.EXCEPTIONS.ALREADYEXISTSEXCEPTION" || response.error.error == "CRM.EXCEPTIONS.ALREADYEXISTSEXCEPTION")
            ) {
                return createResult(
                    ErrorCodes.ADD_ADDRESS_ALREADY_TYPE,
                    response.error
                );
            } else return createResult(ErrorCodes.UNCLASSIFIED_ERROR, response.error);
        }
    } catch (e) {
        console.log("Exception addAddress: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function updateAddress(
    {
        care_of,
        address_line_1,
        address_line_2,
        address_name,
        state_province_county,
        town_city,
        postal_code,
        country_code,
        lat,
        lon,
        is_primary = true,
    },
    addressId
) {
    try {
        //console.log('API: ', contact)
        let id = httpUtil.getSession().sub;
        //console.log('API: ', contact)
        let response = await httpUtil.put({
            resourcePath: "/v1/contacts/" + id + "/addresses/" + addressId,
            body: {
                care_of,
                address_name,
                address_line_1,
                address_line_2,
                state_province_county,
                town_city,
                postal_code,
                country_code,
                is_primary,
                lat,
                lon
            },
            withAccessToken: true,
        });
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception updateAddress: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function removeAddress(addressId) {
    try {
        //console.log('API: ', contact)
        let id = httpUtil.getSession().sub;
        //console.log('API: ', contact)
        let response = await httpUtil.sendDelete({
            resourcePath: "/v1/contacts/" + id + "/addresses/" + addressId,
            withAccessToken: true,
        });
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception removeAddress: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function addPNDeviceToken({
    serial_number,
    registration_type, //IOS or ANDROID
    registration_token,
    mac_address
}) {
    try {
        //console.log('API: ', contact)
        let id = httpUtil.getSession().sub;
        //console.log('API: ', contact)
        let response = await httpUtil.post({
            resourcePath: "/v1/contacts/" + id + "/devices",
            body: {
                serial_number,
                registration_type, //IOS or ANDROID
                registration_token,
                mac_address
            },
            withAccessToken: true,
            logOutIfSessionInvalid: false
        });
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception addDevice: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getContactDevices() {
    try {
        //console.log('API: ', contact)
        let id = httpUtil.getSession().sub;
        //console.log('API: ', contact)
        let response = await httpUtil.get({
            resourcePath: "/v1/contacts/" + id + "/devices",
            withAccessToken: true,
            logOutIfSessionInvalid: false
        });
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception getContactDevices: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getAddresses() {
    try {
        let id = httpUtil.getSession().sub;
        //console.log('API: ', contact)
        let response = await httpUtil.get({
            resourcePath: "/v1/contacts/" + id + "/addresses",
            withAccessToken: true,
        });
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception getAddresses: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getPhones() {
    try {
        //console.log('API: ', contact)
        let id = httpUtil.getSession().sub;
        //console.log('API: ', contact)
        let response = await httpUtil.get({
            resourcePath: "/v1/contacts/" + id + "/phones",
            withAccessToken: true,
        });
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception getPhones: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function updatePhone({ phone_id, number, country_code }) {
    try {
        let id = httpUtil.getSession().sub;
        let response = await httpUtil.put({
            resourcePath: "/v1/contacts/" + id + "/phones/" + phone_id,
            body: {
                number,
                country_code,
            },
            withAccessToken: true,
        });
        if (response.code == "OK")
            return createResult(ErrorCodes.OK, response.data);
        else {
            if (
                response.error && (response.error.error ==
                    "COM.CRM.EXCEPTIONS.CONTACTS.CIMALREADYEXISTSFORANOTHERCONTACTEXCEPTION" || response.error.error ==
                    "COM.CRM.EXCEPTIONS.CIMALREADYEXISTSFORANOTHERCONTACTEXCEPTION")


            ) {
                return createResult(
                    ErrorCodes.PHONE_NUMBER_ALREADY_EXIST,
                    response.error
                );
            } else return createResult(ErrorCodes.UNCLASSIFIED_ERROR, response.error);
        }
    } catch (e) {
        console.log("Exception update phone: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function addPhone({
    is_primary,
    number,
    country_code,
    phone_type = "MOBILE",
}) {
    try {
        let id = httpUtil.getSession().sub;
        let response = await httpUtil.post({
            resourcePath: "/v1/contacts/" + id + "/phones",
            body: {
                is_primary,
                number,
                country_code,
                phone_type,
            },
            withAccessToken: true,
        });
        // return createCommonResult(response);
        if (response.code == "OK")
            return createResult(ErrorCodes.OK, response.data);
        else {
            if (
                response.error &&
                (response.error.error ==
                    "COM.CRM.EXCEPTIONS.CONTACTS.CIMALREADYEXISTSFORANOTHERCONTACTEXCEPTION" || response.error.error ==
                    "COM.CRM.EXCEPTIONS.CIMALREADYEXISTSFORANOTHERCONTACTEXCEPTION")
            ) {
                return createResult(
                    ErrorCodes.PHONE_NUMBER_ALREADY_EXIST,
                    response.error
                );
            } else return createResult(ErrorCodes.UNCLASSIFIED_ERROR, response.error);
        }
    } catch (e) {
        console.log("Exception update phone: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function deletePhone(phone_id) {
    try {
        let id = httpUtil.getSession().sub;
        let response = await httpUtil.sendDelete({
            resourcePath: "/v1/contacts/" + id + "/phones/" + phone_id,
            withAccessToken: true,
        });
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception update phone: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getContactPurchases({
    page = 1,
    size = 10,
    sort = 'performedOn', //='UPDATED_DATE',
    order, //='DESC',
    from_date,
    to_date, //epoch time
} = {}) {
    try {
        let id = httpUtil.getSession().sub;
        //console.log('API: ', contact)
        let response = await httpUtil.get({
            resourcePath: "/v1/contacts/" + id + "/purchases",
            queryParams: {
                page,
                size,
                sort,
                order,
                from_date,
                to_date,
            },
            withAccessToken: true,
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception getContactPurchases: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function changePassword(new_password) {
    try {
        let id = httpUtil.getSession().sub;
        let response = await httpUtil.post({
            resourcePath: "/v1/contacts/" + id + "/change_password",
            body: {
                password: new_password,
            },
        });
        if(response.code === 'OK'){
            return createResult(ErrorCodes.OK, response.data);
        }else {
            if (response.error && response.error.error == "COM.CRM.EXCEPTIONS.INVALIDCONTACTPASSWORDEXCEPTION") {
                return createResult("INVALID_CONTACTPASSWORD_EXCEPTION", response.error);
            }else return createResult(ErrorCodes.UNCLASSIFIED_ERROR, response.error);
        }
    } catch (e) {
        console.log("Exception changePassword: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function createReferral(referral_code) {
    try {
        let response = await httpUtil.post({
            resourcePath: "/v1/referrals",
            body: {
                referral_code: referral_code,
            },
        });
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception update phone: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function signOut() {
    try {
        let id = httpUtil.getSession().sub;
        let response = await httpUtil.post({
            resourcePath: "/v1/contacts/" + id + "/sign_out",
            body: {},
            withAccessToken: true,
        });
        if (response.code == "OK") {
            httpUtil.cleanSession();
            return createResult(ErrorCodes.OK, response.data);
        }

        // //clear session anyway
        // httpUtil.cleanSession();
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception register: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getListPaymentMethods({
    page = 1,
    size = 10,
    sort, //='UPDATED_DATE',
    order, //='DESC',
} = {}) {
    try {
        let id = httpUtil.getSession().sub;
        //console.log('API: ', contact)
        let response = await httpUtil.get({
            resourcePath: "/v1/contacts/" + id + "/payment_methods",
            queryParams: {
                page,
                size,
                sort,
                order,
            },
            withAccessToken: true,
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception getContactPurchases: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function createFormToAddCard(redirect_url) {
    let plus_path = "";
    if (redirect_url) {
        plus_path = "&redirect_url=" + redirect_url
    }
    try {
        let response = await httpUtil.get({
            resourcePath: "/v1/jcc/form?action=CREATE" + plus_path,
            withAccessToken: true,
            returnText: true,
            //queryParams: {
            //redirect_url: redirect_url
            //},
        });

        return createCommonResult(response);
    } catch (e) {
        console.log("Exception register: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function removePaymentMethod(payment_method_id) {
    try {
        let id = httpUtil.getSession().sub;
        let response = await httpUtil.sendDelete({
            resourcePath:
                "/v1/contacts/" + id + "/payment_methods/" + payment_method_id,
            withAccessToken: true,
        });
        console.log('removePaymentMethod===  response', response)
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception register: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}
async function addPaymentMethod({
    payment_method_type = 'CARD',
    first6,
    last4,
    card_token,
    country_of_issue,
    gateway = "JCC_MERCHANT",
    brand
}) {
    try {
        let id = httpUtil.getSession().sub;
        let response = await httpUtil.post({
            resourcePath: "/v1/contacts/" + id + "/payment_methods",
            body: {
                payment_method_type,
                card: {
                    brand:brand,
                    first6: first6,
                    last4: last4,
                    gateway_token: [{
                        gateway: gateway,
                        token: card_token
                    }],
                    country_of_issue: country_of_issue
                }
            },
            withAccessToken: true
        });
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception update phone: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}
async function addFingerprints(cardNumber) {
    try {
        cardNumber = cardNumber.replace(/\s/g, '');
        let id = httpUtil.getSession().sub;
        let response = await httpUtil.post({
            resourcePath: "/v1/contacts/" + id + "/fingerprints",
            body: {
                gateway: "JCC_MERCHANT",
                card_number: cardNumber
            },
            withAccessToken: true
        });
        if (response.code == "OK")
            return createResult(ErrorCodes.OK, response.data);
        else {
            var error = response.error;
            if (error && error.parameters && error.parameters.length > 1) {
                if (error.parameters[1] && error.parameters[1].includes('already EXIST')) {
                    return createResult(ErrorCodes.CARD_ALREADY_EXIT, response);
                }
            }
            return createCommonResult(response);
        }

    } catch (e) {
        console.log("Exception update phone: ", e);
    }
}
async function forgotPassword(email) {
    try {
        let response = await httpUtil.post({
            resourcePath: "/v1/contacts/forgot_password",
            body: {
                username: email,
            },
            logOutIfSessionInvalid: false
        });
        if (response.code == "OK")
            return createResult(ErrorCodes.OK, response.data);
        else {
            if (response.error && response.error.error == "COM.CRM.EXCEPTIONS.INVALIDVALUEEXCEPTION") {
                return createResult(ErrorCodes.FORGOT_EMAIL_NOT_FOUND_EXCEPTION, response.error);
            } else if (response.code == '429') {
                return createResult(ErrorCodes.TOO_MANY_REQUESTS, response.error);
            } else return createResult(ErrorCodes.UNCLASSIFIED_ERROR, response.error);
        }
    } catch (e) {
        console.log("Exception update phone: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function setPrimaryCard(payment_method_id) {
    try {
        //console.log('API: ', contact)
        let id = httpUtil.getSession().sub;
        //console.log('API: ', contact)
        let response = await httpUtil.put({
            resourcePath: "/v1/contacts/" + id + "/payment_methods/" + payment_method_id,
            body: {
                is_primary: true
            },
            withAccessToken: true,
        });
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception updateAddress: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function addApplicationUsage(applicationID, platform) {
    try {
        //console.log('API: ', contact)
        let id = httpUtil.getSession().sub;
        //console.log('API: ', contact)
        let response = await httpUtil.post({
            resourcePath: "/v1/contacts/" + id + "/applications",
            body: {
                application_id: applicationID,
                platform: platform
            },
            withAccessToken: true,
        });
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception updateAddress: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function addContactPreferences(organisation_id, type) {
    try {
        let id = httpUtil.getSession().sub;
        let response = await httpUtil.post({
            resourcePath: "/v1/contacts/" + id + "/preferences",
            body: {
                organisation_id: organisation_id,
                type: type ? type : 'ORDERS'
            },
            withAccessToken: true
        });
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception register: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}


async function getContactPreferences() {
    try {
        let id = httpUtil.getSession().sub;
        //console.log('API: ', contact)
        let response = await httpUtil.get({
            resourcePath: "/v1/contacts/" + id + "/preferences",
            queryParams: {},
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception register: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function sendCredentialsOTP({ send_method, name, value }) {
    try {
        console.log('sendOTP: ', send_method)
        console.log('sendOTP: ', name)
        console.log('sendOTP: ', value)
        let response = await httpUtil.post({
            resourcePath: "/v1/contacts/otp",
            body: {
                send_method: send_method,
                credentials: [
                    {
                        name: name,
                        value: value,
                    },
                ],
            },
            logOutIfSessionInvalid: false
        });
        //check return code here instead of put as there would be different intepretation for different API

        console.log("sendCredentialsOTP response===", response)
        if (response.code == "OK")
            return createCommonResult(response);
        else {
            if (
                response.error &&
                response.error.error == "COM.CRM.EXCEPTIONS.CONTACTUNIQUELYIDENTIFYEXCEPTION"
            ) {
                return createResult(
                    ErrorCodes.CONTACTUNIQUELYIDENTIFYEXCEPTION,
                    response.error
                );
            } else if (
                response.error && (
                    response.error.error == "COM.CRM.EXCEPTIONS.NOTFOUNDEXCEPTION" || response.error.error == "CRM.EXCEPTIONS.NOTFOUNDEXCEPTION")
            ) {
                return createResult(
                    ErrorCodes.NOTFOUNDEXCEPTION,
                    response.error
                );
            } else if (response.code == '429' || response.code == 429) {
                return createResult(ErrorCodes.TOO_MANY_REQUESTS, response.error);
            } else return createResult(ErrorCodes.UNCLASSIFIED_ERROR, response.error);
        }
    } catch (e) {
        console.log("Exception register: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function sendCredentialsMultipleOTP({ send_method, credentials }) {
    try {
        console.log('sendOTP: ', send_method)
        let response = await httpUtil.post({
            resourcePath: "/v1/contacts/otp",
            body: {
                send_method: send_method,
                credentials: credentials
            },
            logOutIfSessionInvalid: false
        });
        //check return code here instead of put as there would be different intepretation for different API

        console.log("sendCredentialsOTP response===", response)
        if (response.code == "OK")
            return createCommonResult(response);
        else {
            if (
                response.error &&
                response.error.error == "COM.CRM.EXCEPTIONS.CONTACTUNIQUELYIDENTIFYEXCEPTION"
            ) {
                return createResult(
                    ErrorCodes.CONTACTUNIQUELYIDENTIFYEXCEPTION,
                    response.error
                );
            } else if (
                response.error && (
                    response.error.error == "COM.CRM.EXCEPTIONS.NOTFOUNDEXCEPTION" || response.error.error == "CRM.EXCEPTIONS.NOTFOUNDEXCEPTION")
            ) {
                return createResult(
                    ErrorCodes.NOTFOUNDEXCEPTION,
                    response.error
                );
            } else if (response.code == '429' || response.code == 429) {
                return createResult(ErrorCodes.TOO_MANY_REQUESTS, response.error);
            } else return createResult(ErrorCodes.UNCLASSIFIED_ERROR, response.error);
        }
    } catch (e) {
        console.log("Exception register: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}
async function validateCredentialsOTP({ phone, auth_otp, otp }) {
    try {
        console.log('validateOTP auth_otp: ', auth_otp)
        console.log('validateOTP otp: ', otp)
        let response = await httpUtil.post({
            resourcePath: "/v1/contacts/validate-otp",
            body: {
                credentials: [
                    {
                        name: "AUTH_OTP",
                        value: auth_otp,
                    },
                ],
                code: otp,
                remember_me: false,
            },
            logOutIfSessionInvalid: false
        });
        if (response.code == "OK")
            return createResult(ErrorCodes.OK, response.data);
        else {
            if (
                response.error &&
                response.error.message == "COM.CRM.EXCEPTIONS.INVALIDLOGINEXCEPTION"
            ) {
                return createResult(ErrorCodes.INVALID_LOGIN, response.error);
            } else return createResult(ErrorCodes.UNCLASSIFIED_ERROR, response.error);
        }
    } catch (e) {
        console.log("Exception register: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}
async function credentialsByEmail(email, password, id, accessToken, validation_required) {
    //console.log('credentialsByEmail email: ', email)
    //console.log('credentialsByEmail accessToken: ', accessToken)
    try {

        let response = await httpUtil.post({
            resourcePath: "/v1/contacts/" + id + "/credentials",
            body: {
                identity: {
                    provider: "EMAIL",
                    username: email,
                    password: password,
                    validation_required: validation_required != null || validation_required != undefined ? validation_required : true,
                }
            },
            withAccessToken: true,
            accessToken: accessToken
        });
        console.log('credentialsByEmail response=', response)
        if (response.code == "OK")
            return createResult(ErrorCodes.OK, response.data);
        else {
            console.log("response:", response.error)
            if (response.error && (response.error.error == "COM.CRM.EXCEPTIONS.ALREADYEXISTSEXCEPTION" || response.error.error == "CRM.EXCEPTIONS.ALREADYEXISTSEXCEPTION")) {
                return createResult(
                    ErrorCodes.REGISTRATION_FAIL_CONTACT_EXISTS,
                    response.error
                );
            } else if (response.error && (response.error.error == "COM.CRM.EXCEPTIONS.INVALIDPASSWORDEXCEPTION" || response.error.error == "CRM.EXCEPTIONS.INVALIDPASSWORDEXCEPTION")) {
                return createResult(
                    ErrorCodes.INVALID_PASSWORD_EXCEPTION,
                    response.error
                );
            } else if (response.error && (response.error.error == "COM.CRM.EXCEPTIONS.INVALIDCONTACTPASSWORDEXCEPTION" || response.error.error == "CRM.EXCEPTIONS.INVALIDCONTACTPASSWORDEXCEPTION")) {
                return createResult(
                    "INVALID_CONTACTPASSWORD_EXCEPTION",
                    response.error
                );
            }
            else return createResult(ErrorCodes.UNCLASSIFIED_ERROR, response.error);
        }
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception register: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}
async function credentialsByPhone(phone, id, country_code, accessToken) {
    try {
        let response = await httpUtil.post({
            resourcePath: "/v1/contacts/" + id + "/credentials",
            body: {
                identity: {
                    provider: "PHONE",
                    phone_number: phone,
                    country_code: country_code,
                    validation_required: true,
                }
            },
            withAccessToken: true,
            accessToken: accessToken
        });
        //check return code here instead of put as there would be different intepretation for different API
        if (response.code == "OK")
            return createResult(ErrorCodes.OK, response.data);
        else {
            if (
                response.error &&
                response.error.error == "COM.CRM.EXCEPTIONS.ALREADYEXISTSEXCEPTION"
            ) {
                return createResult(
                    ErrorCodes.REGISTRATION_FAIL_CONTACT_EXISTS,
                    response.error
                );
            } else return createResult(ErrorCodes.UNCLASSIFIED_ERROR, response.error);
        }
    } catch (e) {
        console.log("Exception register: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}
async function credentialsByEmailOTP(email, id, accessToken) {
    try {
        let response = await httpUtil.post({
            resourcePath: "/v1/contacts/" + id + "/credentials",
            body: {
                identity: {
                    provider: "EMAIL",
                    username: email,
                    validation_required: true,
                }
            },
            withAccessToken: true,
            accessToken: accessToken
        });
        //check return code here instead of put as there would be different intepretation for different API
        if (response.code == "OK")
            return createResult(ErrorCodes.OK, response.data);
        else {
            if (
                response.error &&
                response.error.error == "COM.CRM.EXCEPTIONS.ALREADYEXISTSEXCEPTION"
            ) {
                return createResult(
                    ErrorCodes.REGISTRATION_FAIL_CONTACT_EXISTS,
                    response.error
                );
            } else return createResult(ErrorCodes.UNCLASSIFIED_ERROR, response.error);
        }
    } catch (e) {
        console.log("Exception register: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function findAddress({
    integration = 'GOOGLE',
    address,
    latlng,
} = {}) {
    try {
        let id = httpUtil.getSession().sub;
        //console.log('API: ', contact)
        let response = await httpUtil.get({
            resourcePath: "/v1/addresses",
            queryParams: {
                integration,
                address,
                latlng
            },
            withAccessToken: true,
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception getContactPurchases: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function reclaimPurchase({
    receipt_code,
    merchant_tap_code,
    venue_tap_code,
    total_amount,
    transaction_code
}) {
    try {
        let id = httpUtil.getSession().sub;
        let response = await httpUtil.put({
            resourcePath: "/v1/purchases/reclaim",
            body: {
                receipt_code,
                merchant_tap_code,
                venue_tap_code,
                total_amount,
                transaction_code
            },
            withAccessToken: true,
        });
        //check return code here instead of put as there would be different intepretation for different API
        if (response.code == "OK")
            return createResult(ErrorCodes.OK, response.data);
        else {
            createResult(ErrorCodes.UNKNOWN, response.error);
        }
    } catch (e) {
        console.log("Exception register: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function requestContactToken({
    intent = 'SPEND',
    spend_amount
}) {
    try {
        let id = httpUtil.getSession().sub;
        let response = await httpUtil.post({
            resourcePath: "/v1/contacts/" + id + "/tokens",
            body: {
                intent,
                spend_amount
            },
            withAccessToken: true,
        });
        //check return code here instead of put as there would be different intepretation for different API
        if (response.code == "OK")
            return createResult(ErrorCodes.OK, response.data);
        else {
            return createCommonResult(response);
        }
    } catch (e) {
        console.log("Exception register: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}


async function getContactTokens({
    intent = 'SPEND'
} = {}) {
    try {
        let id = httpUtil.getSession().sub;
        let response = await httpUtil.get({
            resourcePath: "/v1/contacts/" + id + "/tokens",
            queryParams: {
                intent
            },
            withAccessToken: true,
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception getContactPurchases: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getNameDayRules(first_name) {
    try {
        let response = await httpUtil.get({
            resourcePath: "/v1/name_day_rules",
            queryParams: {
                first_name
            },
            withAccessToken: true,
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception getContactPurchases: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function redeemAPass({
    pin,
    code,
    value
} = {}) {
    try {
        let response = await httpUtil.post({
            resourcePath: "/v1/passes",
            body: {
                pin,
                code,
                value
            },
            withAccessToken: true,
        });
        //check return code here instead of put as there would be different intepretation for different API
        if (response.code == 'OK') {
            return createResult(ErrorCodes.OK, response.data);
        } else if (response.error && (response.error.error == "CRM.EXCEPTIONS.NOTFOUNDEXCEPTION" || response.error.error == "CRM.EXCEPTIONS.INVALIDVALUEEXCEPTION")) {
            return createResult(ErrorCodes.REDEEM_PASS_INVALID, response.error);
        } else if (response.error && (response.error.error == "CRM.EXCEPTIONS.INVALIDLIFECYCLESTATEEXCEPTION" || response.error.error == "COM.CRM.EXCEPTIONS.ONLYACTIVEPASSESCANBEREDEEMEDEXCEPTION")) {
            return createResult(ErrorCodes.REDEEM_PASS_USED, response.error);
        } else {
            return createCommonResult(response);
        }
    } catch (e) {
        console.log("Exception redeemAPass: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getListContactServices({
    sort,
    order,
    page = 1,
    size = 20,
    classification,
} = {}) {
    try {
        let id = httpUtil.getSession().sub;
        let response = await httpUtil.get({
            resourcePath: "/v1/contacts/" + id + "/services",
            queryParams: {
                sort,
                order,
                page,
                size,
                classification,
                include_subscription: true
            },
            withAccessToken: true,
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception getListContactServices: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}
async function getListServiceDevices({
    service_id,
    sort,
    order,
    page = 1,
    size = 10000,
    state,
} = {}) {
    try {
        let response = await httpUtil.get({
            resourcePath: "/v1/services/" + service_id + "/devices",
            queryParams: {
                sort,
                order,
                page,
                size,
                state
            },
            withAccessToken: true,
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception getListContactServices: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getApplePass(orgId) {
    try {
        let contactId = httpUtil.getSession().sub;
        if (!orgId) {
            orgId = httpUtil.getSession().current_organisation_id;
        }
        let url = httpUtil.getURI(false, "/v1/apple_pass/" + orgId + "/contacts/" + contactId);
        return { code: 'OK', data: url };
    } catch (e) {
        console.log("Exception getApplePass: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getGooglePass(orgId) {
    try {
        console.log("httpUtil.getSession()===", httpUtil.getSession());
        let contactId = httpUtil.getSession().sub;
        if (!orgId) {
            orgId = httpUtil.getSession().current_organisation_id;
        }
        let url = httpUtil.getURI(false, "/v1/google_pass/" + orgId + "/contacts/" + contactId);
        return { code: 'OK', data: url };
    } catch (e) {
        console.log("Exception getGooglePass: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getAndroidWalletPass(orgId) {
    try {
        let contactId = httpUtil.getSession().sub;
        if (!orgId) {
            orgId = httpUtil.getSession().current_organisation_id;
        }
        let url = httpUtil.getURI(false, "/v1/android_wallet_pass/" + orgId + "/contacts/" + contactId);
        return { code: 'OK', data: url };
    } catch (e) {
        console.log("Exception getAndroidWalletPass: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getUsageServicesAllowance() {
    try {
        let id = httpUtil.getSession().sub;
        let response = await httpUtil.get({
            resourcePath: "/v1/services/" + id + "/allowance",
            withAccessToken: true,
        });
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception getUsageServicesAllowance: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function onServiceDelivery({
    action, 
    services_to_change,
    subscription_id = null,
}) {
    try {
        let id = httpUtil.getSession().sub;
        let response = await httpUtil.post({
            resourcePath: "/v1/estimates/service_delivery",
            body: {
                action: action,
                services_to_change: services_to_change,
                contact_id: id,
                subscription_id: subscription_id,
            },
            withAccessToken: true,
        });
        if (response.code == "OK")
            return createResult(ErrorCodes.OK, response.data);
        else {
            return createResult(ErrorCodes.UNCLASSIFIED_ERROR, response.error);
        }
    } catch (e) {
        console.log("Exception addAddress: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function onUpdateService(action, service_id, prodId) {
    try {
        let response = await httpUtil.put({
            resourcePath: "/v1/services/" + service_id,
            body: {
                action: action,
                change_to_service: {
                    product_id: prodId,
                }
            },
            withAccessToken: false,
        });
        if (response.code == "OK")
            return createResult(ErrorCodes.OK, response.data);
        else {
            return createResult(ErrorCodes.UNCLASSIFIED_ERROR, response.error);
        }
    } catch (e) {
        console.log("Exception onUpdateService: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function onUpdateSubscription(action, subId, cardId) {
    try {
        let response = await httpUtil.put({
            resourcePath: "/v1/subscriptions/" + subId,
            body: {
                action: action,
                payment_method_id: cardId,

            },
            withAccessToken: false,
        });
        if (response.code == "OK")
            return createResult(ErrorCodes.OK, response.data);
        else {
            return createResult(ErrorCodes.UNCLASSIFIED_ERROR, response.error);
        }
    } catch (e) {
        console.log("Exception onUpdateSubscription: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getCustomers({
    // code,
    email_address,
}) {
    try {
        let response = await httpUtil.get({
            resourcePath: "/v1/customers",
            queryParams: {
                // code,
                email_address,
            },
            withAccessToken: false,
            logOutIfSessionInvalid: false,
            isBackend: true,
            unauthorize: false,
            apiKey: 'df9e40a8-afe9-4cad-b137-bd5f5fbad4a6'//airlink portal
        });
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception getCustomers: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function onUpdateServiceWithBody(service_id, body) {
    try {
        let response = await httpUtil.put({
            resourcePath: "/v1/services/" + service_id,
            body: body,
            withAccessToken: false,
        });
        if (response.code == "OK")
            return createResult(ErrorCodes.OK, response.data);
        else {
            return createResult(ErrorCodes.UNCLASSIFIED_ERROR, response.error);
        }
    } catch (e) {
        console.log("Exception onUpdateService: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function deleteContact() {
    try {
        let id = httpUtil.getSession().sub;
        let response = await httpUtil.sendDelete({
            resourcePath: "/v1/contacts/" + id,
            withAccessToken: true,
        });
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception delete contact: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getSubscriptonActions() {
    try {
        let id = httpUtil.getSession().sub;
        let response = await httpUtil.get({
            resourcePath: "/v1/contacts/" + id + "/subscriptions/actions",
            withAccessToken: true,
        });
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception getSubscriptonActions: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function changeMwarePassword({
    current_password,
    new_password,
    current_username,
    new_username,
    code,
    integration_id,
    service_id,
    contact_code,
    contact_name,
}) {
    try {
        let id = httpUtil.getSession().sub;
        let response = await httpUtil.post({
            resourcePath: "/v1/provisioning/service_commands",
            body: {
                contact: {
                    id: id,
                    code: contact_code,
                    name: contact_name,
                },
                code: code,
                service_id: service_id,
                integration_id: integration_id,
                metadata_attributes: [
                    {
                        key: "current_username",
                        value: current_username,
                    },
                    {
                        key: "current_password",
                        value: current_password,
                    },
                    {
                        key: "new_username",
                        value: new_username,
                    },
                    {
                        key: "new_password",
                        value: new_password,
                    },
                ]
            },
        });
        if(response.code === 'OK'){
            return createResult(ErrorCodes.OK, response.data);
        }else {
            if (response.error && response.error.error == "COM.CRM.EXCEPTIONS.INVALIDCONTACTPASSWORDEXCEPTION") {
                return createResult("INVALID_CONTACTPASSWORD_EXCEPTION", response.error);
            }else return createResult(ErrorCodes.UNCLASSIFIED_ERROR, response.error);
        }
    } catch (e) {
        console.log("Exception changeMwarePassword: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getPurchaseInfo(purchaseId) {
    try {
        let response = await httpUtil.get({
            resourcePath: "/v1/purchases/" + purchaseId,
            withAccessToken: true,
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception getContactPurchases: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}

async function getListPaymentMethodsV2({
    page = 1,
    size = 10,
    sort, //='UPDATED_DATE',
    order, //='DESC',
} = {}) {
    try {
        let id = httpUtil.getSession().sub;
        //console.log('API: ', contact)
        let response = await httpUtil.get({
            resourcePath: "/v2/contacts/" + id + "/payment_methods",
            queryParams: {
                page,
                size,
                sort,
                order,
            },
            withAccessToken: true,
        });
        //check return code here instead of put as there would be different intepretation for different API
        return createCommonResult(response);
    } catch (e) {
        console.log("Exception getContactPurchases: ", e);
        return createResult(ErrorCodes.UNKNOWN, e);
    }
}
